import { useContextMatchParams } from 'contexts/matchParams';
import { useContextCurrentSite } from 'contexts';
import { sitesId } from 'core/constants';
import { PATH } from 'envs';
import { useEffect, useState } from 'react';
import { makeRequest } from 'utils';
import { excludes } from '../../constants/api';

export default function useManualPages({ regionId = 'C108' }) {
  const { matchParams } = useContextMatchParams();
  const { currentSite } = useContextCurrentSite();
  const { electionNumber, type, year } = matchParams;
  const urlService = `${PATH}${excludes}${sitesId[currentSite]}/${type}/${electionNumber}/${year}?regionId=${regionId}`;
  const [manualPages, setManualPages] = useState(null);

  useEffect(() => {
    makeRequest(urlService)
      .then(data => {
        setManualPages(data);
      })
      .catch(error => {
        console.log(error);
      });
  }, [urlService]);

  return manualPages;
}
